module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bingdao.c874576b.png";